module.exports = __webpack_public_path__ + "static/media/download-badge.ed3a2bfc.svg";